'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Headline = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Headline = require('./Headline');

var _Headline2 = _interopRequireDefault(_Headline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Headline = _Headline2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-headline')(_Headline2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-headline/lib/cjs/index.js
 ** module id = 269
 ** module chunks = 1
 **/